import { render, staticRenderFns } from "./proDetail.vue?vue&type=template&id=1b2a9646&scoped=true"
import script from "./proDetail.vue?vue&type=script&lang=js"
export * from "./proDetail.vue?vue&type=script&lang=js"
import style0 from "./proDetail.vue?vue&type=style&index=0&id=1b2a9646&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2a9646",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b2a9646')) {
      api.createRecord('1b2a9646', component.options)
    } else {
      api.reload('1b2a9646', component.options)
    }
    module.hot.accept("./proDetail.vue?vue&type=template&id=1b2a9646&scoped=true", function () {
      api.rerender('1b2a9646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/broadcast/product/proDetail.vue"
export default component.exports